import React, { useContext } from 'react';
import Button from '@pds-react/button';
import { Col, Container, Row } from '@pds-react/grid';
import { AppPageProps, AppState, LocalizationContext } from '../app';

const EmailSent: React.FunctionComponent<AppPageProps> = (props: AppPageProps) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const localization = useContext(LocalizationContext)!;

  return (
    <>
      <Container style={{ marginTop: '40px', marginBottom: '40px' }}>
        <Row>
          <Col span={12} sm={{ span: 8, offset: 2 }} md={{ span: 6, offset: 3 }} xl={{ span: 4, offset: 4 }}>
            <div className="pds-typography-center">
              <h1 className="pds-typography-h2">{localization.t('email-sent:page-title')}</h1>
            </div>
            <br />
            <div className="pds-typography-center">
              <p>{localization.t('email-sent:page-description')}</p>
            </div>
            <div className="pds-typography-center">
              <Button
                onClick={() => {
                  props.changeState(AppState.COLLECT_CRD);
                }}
              >
                {localization.t('misc:go-back-button')}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EmailSent;
